// extracted by mini-css-extract-plugin
module.exports = {"container":"NameAnimation-module--container--2FhW4","svgContent":"NameAnimation-module--svgContent--J6Dvf","filling":"NameAnimation-module--filling--e9LmM"};